import { isNullOrUndefined, isObject, isString } from './helpers';
import { AppointmentTokenSchema } from '@ap-angular/shared/schema';

export class UrlEmbedData {
	private static encode(value: any): string {
		if (value === null || value === undefined) return undefined;

		const json = JSON.stringify(value);
		const bytes = new TextEncoder().encode(json);
		let binary = '';
		bytes.forEach(byte => binary += String.fromCharCode(byte));

		return btoa(binary);
	}

	private static decode(value: string): any {
		if (value === null || value === undefined || !isString(value)) return undefined;

		const binary = atob(value);
		const bytes = new Uint8Array(binary.length);

		for (let index = 0; index < binary.length; index++) {
			bytes[index] = binary.charCodeAt(index);
		}

		const json = new TextDecoder().decode(bytes);
		return JSON.parse(json);
	}

	public static encodeAppointmentToken(value: AppointmentTokenSchema): string {
		return isObject(value) ? this.encode(value) : undefined;
	}

	public static decodeAppointmentToken(value: string): AppointmentTokenSchema {
		return isString(value) ? this.decode(value) : undefined;
	}

	public static appointmentTokenValidation(value: string): boolean {
		if (isString(value)) {
			const data: AppointmentTokenSchema = this.decode(value);
			return !isNullOrUndefined(data.startTime && data.endTime && data.widgetToken);
		}
		return undefined;
	}

	public static encodeDate(value: any): string {
		return this.encode({date: value});
	}

	public static decodeDate(value: string): string {
		return this.decode(value).date;
	}

	public static encodeString(value: string): string {
		return this.encode({string: value});
	}

	public static decodeString(value: string): string {
		return this.decode(value).string;
	}
}
